/**
 * Hero component - Header section with slate grey gradients and animated elements
 * Constitutional requirement: React with regular JavaScript
 */

import React from 'react'
import '../hero.css'

import compassImage from '../assets/compass_large_1-removebg-preview.png'

const Hero = () => {
  return (
    <section className="hero-section">
      
      {/* Animated SVG Background for Hero */}
      <div className="hero-animation">
        <svg className="hero-background-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 300" preserveAspectRatio="xMidYMid slice">
        <defs>
          {/* Slate Grey Gradients */}
          <linearGradient id="slateGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#475569" stopOpacity="0.8" />
            <stop offset="50%" stopColor="#64748b" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#94a3b8" stopOpacity="0.4" />
          </linearGradient>
          
          <linearGradient id="slateGradient2" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#334155" stopOpacity="0.7" />
            <stop offset="50%" stopColor="#475569" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#64748b" stopOpacity="0.3" />
          </linearGradient>
          
          <linearGradient id="slateGradient3" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1e293b" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#475569" stopOpacity="0.8" />
          </linearGradient>
          
          <linearGradient id="slateAccent" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#334155" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#64748b" stopOpacity="0.5" />
          </linearGradient>
        </defs>
        
        {/* Flowing slate background shapes */}
        <path 
          className="hero-floating-line hero-floating-line-1"
          d="M-100,80 Q200,40 500,70 T900,60 L1300,65 L1300,-30 L-100,-30 Z" 
          fill="url(#slateGradient1)"
        />
        
        <path 
          className="hero-floating-line hero-floating-line-2"
          d="M-100,180 Q300,140 600,170 T1100,160 L1300,180 L1300,100 L-100,100 Z" 
          fill="url(#slateGradient2)"
        />
        
        <path 
          className="hero-floating-line hero-floating-line-3"
          d="M-100,280 Q400,240 700,260 T1300,240 L1300,350 L-100,350 Z" 
          fill="url(#slateGradient3)"
        />
        
        {/* Dynamic accent lines */}
        <line className="hero-accent-line hero-accent-line-1" x1="0" y1="50" x2="1200" y2="90" stroke="url(#slateAccent)" strokeWidth="2" />
        <line className="hero-accent-line hero-accent-line-2" x1="0" y1="220" x2="1200" y2="260" stroke="url(#slateGradient2)" strokeWidth="1.5" />
        <line className="hero-accent-line hero-accent-line-3" x1="150" y1="0" x2="600" y2="300" stroke="url(#slateGradient3)" strokeWidth="1" />
        
        {/* Animated circles */}
        <circle className="hero-floating-circle hero-floating-circle-1" cx="100" cy="120" r="3" fill="url(#slateGradient1)" />
        <circle className="hero-floating-circle hero-floating-circle-2" cx="900" cy="80" r="2.5" fill="url(#slateGradient2)" />
        <circle className="hero-floating-circle hero-floating-circle-3" cx="150" cy="220" r="3.5" fill="url(#slateGradient3)" />
        <circle className="hero-floating-circle hero-floating-circle-4" cx="1000" cy="200" r="2" fill="url(#slateAccent)" />
        </svg>
      </div>
      
      {/* Hero Content */}
      <header className="hero-header">
        <div className="hero-content">
          <div className="hero-title-section">
            <div className="hero-image">
              <img 
                src={compassImage} 
                alt="Compass Navigation" 
                className="hero-compass"
              />
            </div>
            <h1 className="hero-title">
                <span className="hero-title-primary">Zero Debt </span>
                <span className="hero-title-secondary"> Journey</span>
            </h1>
          </div>
          <p className="hero-subtitle">
            Calculate how long it will take to pay off your credit card debt
          </p>
        </div>
      </header>
      
    </section>
  )
}

export default Hero
